import { ActionType } from "../../action-types";
import { Action } from "../../actions/index";
import { current } from '@reduxjs/toolkit'; // https://stackoverflow.com/questions/57240245/how-do-i-see-state-when-logging-to-the-console-instead-of-proxy-object-inside-re
import produce from "immer";
import _ from 'lodash';

import { GrantViewTypes, ImpactViewTypes, QueryViewTypes, PIViewTypes, MainViewTypes, InteractionTypes } from "../../../types/data";
import { ImpactType } from "../../../types/data.global";


interface InitialState {
  bubbleTreemapGeometryGroup: MainViewTypes.BubbleTreemapGeometryGroup[],
  bubbleTreemapCircumscribedRadiiDict: {[key: string]: number},
  isOptimizingMainViewLayoutFinished: boolean;
  mainviewLayoutOptimizationParams: MainViewTypes.MainViewLayoutOptimizationParams;
  leafNodeSizeScale: any;
  leafNodeSizeScale_ForHighlightedGrantField: any;
  leafNodeSizeScaleType: string;
  testData: string;
  startYear: number[];
  endYear: number[];
  fundingUSD: number[];
  country: string;
  fundingAgency: QueryViewTypes.FunderOrganizationHierarchyUnit;
  subInsitute: QueryViewTypes.FunderOrganizationHierarchyUnit;
  grantIDList: string[];
  // Grant View
  grantViewScatterplotGrantIDList: string[];
  grantViewFunderBarChartData: GrantViewTypes.BarChartDataUnit[];
  grantViewFunderTimelineData: GrantViewTypes.TimelineEntity[];
  grantViewFieldBarChartData: GrantViewTypes.BarChartDataUnit[];
  grantViewFieldTimelineData: GrantViewTypes.TimelineEntity[];
  grantViewScatterChartData: GrantViewTypes.ScatterplotDataUnit[];
  selectedGrantTopicList: GrantViewTypes.SelectedGrantTopicUnit[];
  // PI View
  piViewGenderDonutChartDataOuter: PIViewTypes.DonutChartDataUnit[];
  piViewGenderDonutChartDataInner: PIViewTypes.DonutChartDataUnit[];
  piViewGenderRadarChartData: PIViewTypes.RadarChartEntity[];
  piViewCareerAgeDonutChartDataOuter: PIViewTypes.DonutChartDataUnit[];
  piViewCareerAgeDonutChartDataInner: PIViewTypes.DonutChartDataUnit[];
  piViewCareerAgeRadarChartData: PIViewTypes.RadarChartEntity[];
  piViewUniversityBarChartData: GrantViewTypes.BarChartDataUnit[];
  piViewSciFieldBarChartData: GrantViewTypes.BarChartDataUnit[];
  piViewHIndexAreaChartData: ImpactViewTypes.AreaChartDataUnit[];
  piViewProductivityAreaChartData: ImpactViewTypes.AreaChartDataUnit[];
  piViewCardListData: PIViewTypes.PIStatisticsUnit[];
  piViewPredictedCardListData: PIViewTypes.PIStatisticsUnit[];
  // Impact Type View
  impactStatViewNumOfPaperData: ImpactViewTypes.AreaChartDataUnit[];
  impactStatViewNumOfHitPaperData: ImpactViewTypes.AreaChartDataUnit[];
  impactStatViewNumOfDisruptivePaperData: ImpactViewTypes.AreaChartDataUnit[];
  impactStatViewNumOfPatentData: ImpactViewTypes.AreaChartDataUnit[];
  impactStatViewNumOfClinicalTrailData: ImpactViewTypes.AreaChartDataUnit[];
  impactStatViewNumOfCitingPatentData: ImpactViewTypes.AreaChartDataUnit[];
  impactStatViewNumOfCitingClinicalTrailData: ImpactViewTypes.AreaChartDataUnit[];
  impactStatViewNumOfCitingPolicyData: ImpactViewTypes.AreaChartDataUnit[];
  impactStatViewNumOfCitingNewsfeedData: ImpactViewTypes.AreaChartDataUnit[];
  // Impact Entity View
  impactEntityPaperDirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityPatentDirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityClinicalTrialPhaseDirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityClinicalTrialTypeDirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityPatentIndirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityClinicalTrialPhaseIndirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityClinicalTrialTypeIndirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityPolicyIndirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityPolicySourceCountryIndirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityPolicySourceTitleIndirectData: GrantViewTypes.BarChartDataUnit[];
  impactEntityNewsfeedIndirectData: GrantViewTypes.BarChartDataUnit[];

  impactEntityPaperDirectGrantIdList: string[];
  impactEntityPatentDirectGrantIdList: string[];
  impactEntityClinicalTrialDirectGrantIdList: string[];
  impactEntityPatentIndirectGrantIdList: string[];
  impactEntityClinicalTrialIndirectGrantIdList: string[];
  impactEntityPolicyIndirectGrantIdList: string[];
  impactEntityNewsfeedIndirectGrantIdList: string[];

  impactEntitySearchResult: ImpactViewTypes.ImapctEntitySearchResult;


  // yifang: start
  bubbleTreemapEntityGroupList: MainViewTypes.BubbleTreemapEntityTypeGroup[];
  predictedGrantIDList: string[];
  predictedGrantIDListGlobal: string[];
  predictionSearchResult: MainViewTypes.PredictionSearchResult;
  nodePositionList: MainViewTypes.NodePosition[];
  leafNodePosition_InitialCenter: {
    leafNodePositionList: MainViewTypes.LeafNodePosition[];
    bubbleTreemapEntityTypeCenterXYList: MainViewTypes.BubbleTreemapCenterPositionWarpper[];
  };
  leafNodePosition_BubbleCenter: {
    leafNodePositionList: MainViewTypes.LeafNodePosition[];
    bubbleTreemapEntityTypeCenterXYList: MainViewTypes.BubbleTreemapCenterPositionWarpper[];
  };

  isEntityFieldGraphFinished: boolean;
  isEntityTypeGraphFinished: boolean;
  isDrawGrantTypeNodeFinished: boolean;
  entityTypeLayoutData: any;

  entityFieldGraph_InputData: any[];
  entityFieldGraph_NodeLinkData: {
    nodes: MainViewTypes.EntityTypeNode[],
    links: MainViewTypes.EntityTypeLink[]
  };
  mainviewDataDict: MainViewTypes.MainViewDataDict;
  // {
  //   grantNodeGlyphData: MainViewTypes.GrantNodeGlyphDataUnit[], // state test data: mainviewGrantNodeData,
  //   entityTypeGraphData: MainViewTypes.EntityTypeGraphData,
  //   entityFieldGraphData: {},
  // },
  highlightedImpactFieldNode: MainViewTypes.HighlightedImpactFieldNode;
  highlghtedGrantFieldNode: MainViewTypes.HighlightedGrantFieldNode;
  highlightedGrantFieldData: MainViewTypes.HighlightedGrantFieldData;
  // mainViewData: any;
  grantNodePositionList: MainViewTypes.GrantNodePosition[];

  // yfiang: end

  mainviewImpactSummaryTableData: MainViewTypes.ImpactSummaryViewData;

  // loading related
  mainViewLoadingLabel: string,
  isGrantViewLoading: boolean,
  isPIViewLoading: boolean,
  isImpactEntityViewLoading: boolean,
  isImpactStatisticsViewLoading: boolean,
  isMainViewLoading: boolean,
}

const initialState: InitialState = {
  bubbleTreemapGeometryGroup: [],
  bubbleTreemapCircumscribedRadiiDict: {},
  bubbleTreemapEntityGroupList: [],
  isOptimizingMainViewLayoutFinished: false,
  mainviewLayoutOptimizationParams: {
    Scale: 0,
    EdgeLengthScale: 0,
    Distances: {},
    CentersXY: {},
  },
  leafNodeSizeScaleType: 'linear',
  leafNodeSizeScale: 0,
  leafNodeSizeScale_ForHighlightedGrantField: 0,
  testData: '',
  startYear: [2000, 2020],
  endYear: [2000, 2020],
  fundingUSD: [0, 4000000000],
  country: "",
  fundingAgency: {funderGridID: "", funderName: ""},
  subInsitute: {funderGridID: "", funderName: ""},
  grantIDList: [],
  grantViewScatterplotGrantIDList: [],
  grantViewFunderBarChartData: [],
  grantViewFunderTimelineData: [],
  grantViewFieldBarChartData: [],
  grantViewFieldTimelineData: [],
  grantViewScatterChartData: [],
  selectedGrantTopicList: [],

  piViewGenderDonutChartDataOuter: [
    {
      "Male": 1
    },
    {
      "Female": 1
    }
  ],
  piViewGenderDonutChartDataInner: [
    {
      "Male": 1
    },
    {
      "Female": 1
    }
  ],
  piViewGenderRadarChartData: [
    {
      "Male": [
        { "avg_paper": 0.0, "avg_patent": 0.0, "avg_trial": 0.0, "avg_paper_citation": 0.0, "avg_patent_citation": 0.0, "avg_p0licy_citation": 0.0, "avg_trial_citation": 0.0, "avg_news_citation": 0.0 }
      ],
      "Female": [
        { "avg_paper": 0.0, "avg_patent": 0.0, "avg_trial": 0.0, "avg_paper_citation": 0.0, "avg_patent_citation": 0.0, "avg_p0licy_citation": 0.0, "avg_trial_citation": 0.0, "avg_news_citation": 0.0 }
      ]
    }
  ],
  piViewCareerAgeDonutChartDataOuter: [
    {
      "Senior": 1
    },
    {
      "Middle": 1
    },
    {
      "Junior": 1
    }
  ],
  piViewCareerAgeDonutChartDataInner: [
    {
      "Senior": 1
    },
    {
      "Middle": 1
    },
    {
      "Junior": 1
    }
  ],
  piViewCareerAgeRadarChartData: [
    {
      "Senior": [
        { "avg_paper": 0.0, "avg_patent": 0.0, "avg_trial": 0.0, "avg_paper_citation": 0.0, "avg_patent_citation": 0.0, "avg_p0licy_citation": 0.0, "avg_trial_citation": 0.0, "avg_news_citation": 0.0 }
      ],
      "Middle": [
        { "avg_paper": 0.0, "avg_patent": 0.0, "avg_trial": 0.0, "avg_paper_citation": 0.0, "avg_patent_citation": 0.0, "avg_p0licy_citation": 0.0, "avg_trial_citation": 0.0, "avg_news_citation": 0.0 }
      ],
      "Junior": [
        { "avg_paper": 0.0, "avg_patent": 0.0, "avg_trial": 0.0, "avg_paper_citation": 0.0, "avg_patent_citation": 0.0, "avg_p0licy_citation": 0.0, "avg_trial_citation": 0.0, "avg_news_citation": 0.0 }
      ]
    }
  ],
  piViewUniversityBarChartData: [],
  piViewSciFieldBarChartData: [],
  piViewHIndexAreaChartData: [],
  piViewProductivityAreaChartData: [],
  piViewCardListData: [],
  piViewPredictedCardListData: [],

  impactStatViewNumOfPaperData: [],
  impactStatViewNumOfHitPaperData: [],
  impactStatViewNumOfDisruptivePaperData: [],
  impactStatViewNumOfPatentData: [],
  impactStatViewNumOfClinicalTrailData: [],
  impactStatViewNumOfCitingPatentData: [],
  impactStatViewNumOfCitingClinicalTrailData: [],
  impactStatViewNumOfCitingPolicyData: [],
  impactStatViewNumOfCitingNewsfeedData: [],


  impactEntityPaperDirectData: [],
  impactEntityPatentDirectData: [],
  impactEntityClinicalTrialPhaseDirectData: [],
  impactEntityClinicalTrialTypeDirectData: [],
  impactEntityPatentIndirectData: [],
  impactEntityClinicalTrialPhaseIndirectData: [],
  impactEntityClinicalTrialTypeIndirectData: [],
  impactEntityPolicyIndirectData: [],
  impactEntityPolicySourceCountryIndirectData: [],
  impactEntityPolicySourceTitleIndirectData: [],
  impactEntityNewsfeedIndirectData: [],

  impactEntityPaperDirectGrantIdList: [],
  impactEntityPatentDirectGrantIdList: [],
  impactEntityClinicalTrialDirectGrantIdList: [],
  impactEntityPatentIndirectGrantIdList: [],
  impactEntityClinicalTrialIndirectGrantIdList: [],
  impactEntityPolicyIndirectGrantIdList: [],
  impactEntityNewsfeedIndirectGrantIdList: [],

  impactEntitySearchResult: {
    "entity": "",
    "fieldCodeList": []
  },

  // yifang: start
  predictedGrantIDList: [],
  predictedGrantIDListGlobal: [],
  predictionSearchResult: {
    entity: '',
    fieldIDList: [],
  },
  nodePositionList: [],
  leafNodePosition_InitialCenter: {
    leafNodePositionList: [],
    bubbleTreemapEntityTypeCenterXYList: [],
  },
  leafNodePosition_BubbleCenter: {
    leafNodePositionList: [],
    bubbleTreemapEntityTypeCenterXYList: [],
  },
  isEntityFieldGraphFinished: false,
  entityTypeLayoutData: null,
  entityFieldGraph_InputData: [],
  entityFieldGraph_NodeLinkData: {
    nodes: [],
    links: [],
  },
  mainviewDataDict: {
    grantNodeGlyphData: [], // state test data: mainviewGrantNodeData,
    entityTypeGraphData: {
      direct_impact: {
        nodes: [],
        links: [],
      },
      indirect_impact_folded: {
        nodes: [],
        links: [],
      },
      indirect_impact_unfolded: {
        nodes: [],
        links: [],
      },
    } as MainViewTypes.EntityTypeGraphData,
    entityFieldGraphData: {},
    predictionDataDict: {} as MainViewTypes.PredictionResultDict,
    wordleData: {
      grantHistoricalFlow: {} as MainViewTypes.GrantWordleData,
      grantPredictionFlow: {} as MainViewTypes.GrantWordleData,
      directImpact: [],
      indirectImpact: [],
    },
  },
  highlightedImpactFieldNode: {
    impactType: ImpactType.DIRECT_IMPACT,
    impactEntity: '',
    impactFieldID: '',
  },
  highlghtedGrantFieldNode: {
    grantFieldID: '',
    grantFieldName: '',
    impactType: ImpactType.DIRECT_IMPACT,
  },
  highlightedGrantFieldData: {},
  // mainViewData: mainviewData_IndirectImpact, //, mainviewData_IndirectImpact, // mainviewDataAll.direct_impact,
  grantNodePositionList: [],
  isDrawGrantTypeNodeFinished: false,
  isEntityTypeGraphFinished: false,
  // yifang: end

  mainviewImpactSummaryTableData: {
    fundingAmount: { attrName: 'Funding Amount', attrValue: 0 },
    numGrant: { attrName: 'Num of Grants', attrValue: 0 },
    numPaper: { attrName: 'Paper', attrValue: 0 },
    numPatent: { attrName: 'Patent', attrValue: 0 },
    numClinicalTrial: { attrName: 'Clinical Trial', attrValue: 0 },
    numCitingPaper: { attrName: 'Paper Citation', attrValue: 0 },
    numCitingPatent: { attrName: 'Patent Citation', attrValue: 0 },
    numCitingClinicalTrial: { attrName: 'Clinical Trial Citation', attrValue: 0 },
    numCitingPolicy: { attrName: 'Policy Citation', attrValue: 0 },
    numCitingNews: { attrName: 'Newsfeed Citation', attrValue: 0 },
  },

  // loading related
  mainViewLoadingLabel: 'Loading...',
  isGrantViewLoading: false,
  isPIViewLoading: false,
  isImpactEntityViewLoading: false,
  isImpactStatisticsViewLoading: false,
  isMainViewLoading: false,
};

const reducer = produce((state: InitialState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.ONCLICK_IMPACT_FIELD_NODE:
      state.highlightedImpactFieldNode = action.payload
      break
    case ActionType.UPDATE_LEAF_NODE_SIZE_SCALE_FOR_HIGHLIGHTED_GRANT_FIELD:
      state.leafNodeSizeScale_ForHighlightedGrantField = action.leafNodeSizeScaleForHighlightedGrantField
      state.leafNodeSizeScaleType = action.leafNodeSizeScaleType
      break
    case ActionType.UPDATE_BUBBLE_TREEMAP_GEOMETRY_GROUP:
      state.bubbleTreemapGeometryGroup = action.bubbleTreemapGeometryGroup
      break
    case ActionType.UPDATE_BUBBLE_TREEMAP_CIRCUMSCRIBED_RADII_DICT:
      state.bubbleTreemapCircumscribedRadiiDict = action.bubbleTreemapCircumscribedRadiiDict
      break
    case ActionType.UPDATE_BUBBLE_TREEMAP_ENTITY_GROUP_LIST:
      state.bubbleTreemapEntityGroupList = action.bubbleTreemapEntityGroupList
      break
    case ActionType.IS_OPTIMIZING_MAINVIEW_LAYOUT_FINISHED:
      state.isOptimizingMainViewLayoutFinished = action.isOptimizingMainViewLayoutFinished
      break
    case ActionType.GET_MAINVIEW_LAYOUT_OPTIMIZATION_PARAMS:
      state.mainviewLayoutOptimizationParams = action.payload
      break
    case ActionType.UPDATE_LEAF_NODE_SIZE_SCALE:
      state.leafNodeSizeScale = action.leafNodeSizeScale
      state.leafNodeSizeScaleType = action.leafNodeSizeScaleType
      break
    case ActionType.UPDATE_PREDICTION_GRANTIDLIST_4_PI_VIEW:
      // console.log('==> show PI prediction grant id list: ')
      // console.log('predictedGrantIDList: ', action.predictedGrantIDList)
      // console.log('predictedGrantIDListGlobal: ', action.predictedGrantIDListGlobal)
      state.predictedGrantIDList = action.predictedGrantIDList
      state.predictedGrantIDListGlobal = action.predictedGrantIDListGlobal
      break
    case ActionType.UPDATE_PREDICTION_SEARCH_RESULT:
      state.predictionSearchResult = action.predictionSearchResult
      break
    case ActionType.GET_BACKEND_DATA:
      state.testData = action.payload
      break
    case ActionType.GET_GRANT_ID_LIST:
      // console.log('==> get initial grant data: ', action.payload)
      state.grantIDList = action.payload
      state.grantViewScatterplotGrantIDList = action.payload
      break
    case ActionType.GET_GRANT_ID_LIST_USING_GRANT_FIELD:
      state.grantIDList = action.payload
      break
    case ActionType.SET_SELECTED_GRANT_TOPIC_LIST:
      state.selectedGrantTopicList = action.selectedGrantTopicList
      break
    case ActionType.GET_GRANT_VIEW_DATA:
      // state.grantViewFunderBarChartData = action.payload.funderBarChartData
      // state.grantViewFunderTimelineData = action.payload.funderTimelineData
      state.grantViewFieldBarChartData = action.payload.fieldBarChartData
      state.grantViewFieldTimelineData = action.payload.fieldTimelineData
      state.grantViewScatterChartData = action.payload.scatterplotData
      break
    // case ActionType.GET_GRANT_VIEW_FIELD_SUBVIEW_DATA:
    //   state.grantViewFunderBarChartData = action.payload.funderBarChartData
    //   state.grantViewFunderTimelineData = action.payload.funderTimelineData
    //   state.grantViewFieldBarChartData = action.payload.fieldBarChartData
    //   state.grantViewFieldTimelineData = action.payload.fieldTimelineData
    //   // state.grantViewScatterChartData = action.payload.scatterplotData
    //   break
    case ActionType.GET_PI_VIEW_DATA:
      state.piViewGenderDonutChartDataOuter = action.payload.genderDonutChartDataOuter
      state.piViewGenderDonutChartDataInner = action.payload.genderDonutChartDataInner
      state.piViewGenderRadarChartData = action.payload.genderRadarChartData
      state.piViewCareerAgeDonutChartDataOuter = action.payload.careerAgeDonutChartDataOuter
      state.piViewCareerAgeDonutChartDataInner = action.payload.careerAgeDonutChartDataInner
      state.piViewCareerAgeRadarChartData = action.payload.careerAgeRadarChartData
      state.piViewUniversityBarChartData = action.payload.universityBarChartData
      state.piViewSciFieldBarChartData = action.payload.sciFieldBarChartData
      state.piViewHIndexAreaChartData = [{ "hIndex": action.payload.scisciMetricAreaChartData.hIndex }];
      state.piViewProductivityAreaChartData = [{ "productivity": action.payload.scisciMetricAreaChartData.productivity }];
      break
    case ActionType.GET_PI_VIEW_CARD_LIST_DATA:
      state.piViewCardListData = action.payload
      break
    case ActionType.GET_PI_VIEW_PREDICTED_CARD_LIST_DATA:
      state.piViewPredictedCardListData = action.payload
      break
    case ActionType.GET_IMPACT_STATISTICS_VIEW_DATA:
      state.impactStatViewNumOfPaperData = action.payload.numPaperAreaChartData
      state.impactStatViewNumOfHitPaperData = action.payload.numHitPaperAreaChartData
      state.impactStatViewNumOfDisruptivePaperData = action.payload.numDisruptivePaperAreaChartData
      state.impactStatViewNumOfPatentData = action.payload.numPatentAreaChartData
      state.impactStatViewNumOfClinicalTrailData = action.payload.numClinicalTrialAreaChartData
      state.impactStatViewNumOfCitingPatentData = action.payload.numCitingPatentAreaChartData
      state.impactStatViewNumOfCitingClinicalTrailData = action.payload.numCitingClinicalTrialAreaChartData
      state.impactStatViewNumOfCitingPolicyData = action.payload.numCitingPolicyAreaChartData
      state.impactStatViewNumOfCitingNewsfeedData = action.payload.numCitingNewsfeedAreaChartData
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_DIRECT_PAPER_DATA:
      state.impactEntityPaperDirectData = action.payload.barchartData
      state.impactEntityPaperDirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_DIRECT_PATENT_DATA:
      state.impactEntityPatentDirectData = action.payload.barchartData
      state.impactEntityPatentDirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_DIRECT_CLINICAL_TRIAL_DATA:
      state.impactEntityClinicalTrialPhaseDirectData = action.payload.barchartData
      state.impactEntityClinicalTrialDirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_DIRECT_CLINICAL_TRIAL_TYPE_DATA:
      state.impactEntityClinicalTrialTypeDirectData = action.payload.barchartData
      // state.impactEntityClinicalTrialDirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_PATENT_DATA:
      state.impactEntityPatentIndirectData = action.payload.barchartData
      state.impactEntityPatentIndirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_CLINICAL_TRIAL_DATA:
      state.impactEntityClinicalTrialPhaseIndirectData = action.payload.barchartData
      state.impactEntityClinicalTrialIndirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_CLINICAL_TRIAL_TYPE_DATA:
      state.impactEntityClinicalTrialTypeIndirectData = action.payload.barchartData
      // state.impactEntityClinicalTrialDirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_POLICY_DATA:
      state.impactEntityPolicyIndirectData = action.payload.barchartData
      state.impactEntityPolicyIndirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_POLICY_SOURCE_COUNTRY_DATA:
      state.impactEntityPolicySourceCountryIndirectData = action.payload.barchartData
      // state.impactEntityPolicyIndirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_POLICY_SOURCE_TITLE_DATA:
      state.impactEntityPolicySourceTitleIndirectData = action.payload.barchartData
      // state.impactEntityPolicyIndirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_NEWSFEED_DATA:
      state.impactEntityNewsfeedIndirectData = action.payload.barchartData
      state.impactEntityNewsfeedIndirectGrantIdList = action.payload.updatedGrantIdList
      break
    case ActionType.SEARCH_IMPACT_ENTITY_VIEW_PAPER_DATA:
      // state.impactEntityPaperDirectData = action.payload.barchartData
      state.impactEntitySearchResult = action.payload.searchResultList
      break
    case ActionType.SEARCH_IMPACT_ENTITY_VIEW_PATENT_DATA:
      // state.impactEntityPatentDirectData = action.payload.barchartData
      state.impactEntitySearchResult = action.payload.searchResultList
      break
    case ActionType.SEARCH_IMPACT_ENTITY_VIEW_CLINICAL_TRIAL_DATA:
      // state.impactEntityClinicalTrialPhaseDirectData = action.payload.barchartData
      state.impactEntitySearchResult = action.payload.searchResultList
      break
    case ActionType.SEARCH_IMPACT_ENTITY_VIEW_POLICY_DATA:
      // state.impactEntityPolicyIndirectData = action.payload.barchartData
      state.impactEntitySearchResult = action.payload.searchResultList
      break

    // yifang: start
    case ActionType.UPDATE_NODE_POSITION_LIST:
      state.nodePositionList = action.nodePositionList
      break
    case ActionType.UPDATE_LEAF_NODE_INITIAL_POSITION_LIST:
      state.leafNodePosition_InitialCenter = action.payload
      break
    case ActionType.UPDATE_LEAF_NODE_POSITION_LIST:
      state.leafNodePosition_BubbleCenter = action.payload
      break
    case ActionType.UPDATE_ENTITY_FIELD_GRAPH_NODE_LINK_DATA:
      state.entityFieldGraph_NodeLinkData = action.entityFieldGraph_NodeLinkData
      break
    case ActionType.UPDATE_IS_ENTITY_FIELD_GRAPH_FINISHED:
      state.isEntityFieldGraphFinished = action.isfinished
      break
    case ActionType.UPDATE_IS_ENTITY_TYPE_GRAPH_FINISHED:
      state.isEntityTypeGraphFinished = action.isfinished
      break
    case ActionType.UPDATE_ENTITY_TYPE_LAYOUT_DATA:
      state.entityTypeLayoutData = action.payload
      break
    case ActionType.UPDATE_ENTITY_FIELD_GRAPH_INPUT_DATA:
      state.entityFieldGraph_InputData = action.entityFieldGraph_InputData
      break
    case ActionType.GET_MAINVIEW_DATA:
      state.mainviewDataDict = action.mainviewData
      // console.log('dataReducer: mainviewDataDict', state.mainviewDataDict)
      break
    case ActionType.UPDATE_GRANT_FIELD_NODE_POSITION:
      state.grantNodePositionList = action.payload.grantNodePositionList
      state.isDrawGrantTypeNodeFinished = action.payload.isDrawGrantTypeNodeFinished
      break
    case ActionType.ONCLICK_GRANT_FIELD_NODE:
      state.highlghtedGrantFieldNode = action.payload
      const grantFieldID = action.payload.grantFieldID
      const impactType = action.payload.impactType

      // console.log('dataReducer: \ngrantFieldID: ', grantFieldID, typeof(grantFieldID))
      // console.log('dataReducer: \nimpactType: ', impactType)
      // console.log('dataReducer: \nstate.mainviewDataDict.entityFieldGraphData: ', state.mainviewDataDict.entityFieldGraphData)
      // console.log('dataReducer: \nstate.mainviewDataDict.entityFieldGraphData[impactType]: ', state.mainviewDataDict.entityFieldGraphData[impactType])

      if (grantFieldID === '') {
        state.highlightedGrantFieldData = {}
      } else {
        // 1. fetch data
        // new version (nhb-ftf-2025):
        let grantFieldDataList: any[] = []
        if (impactType === ImpactType.DIRECT_IMPACT) {
          grantFieldDataList = state.mainviewDataDict.entityFieldGraphData[impactType]['grant_field_level_data']['node']
        } else if (impactType === ImpactType.INDIRECT_IMPACT_FOLDED || impactType === ImpactType.INDIRECT_IMPACT_UNFOLDED) {
          grantFieldDataList = state.mainviewDataDict.entityFieldGraphData['indirect_impact']['grant_field_level_data']['node']
        } else {
          console.log('error in dataReducer: impactType is not supported!')
        }
        // // old version (vis2024):
        // const grantFieldDataList = state.mainviewDataDict.entityFieldGraphData['indirect_impact']['grant_field_level_data']['node'] // temp, hard code
        // // const grantFieldDataList = mainviewDataAll['direct_impact']['grant_field_level_data']['node']

        // 2. filter data
        const highlightedGrantFieldData = grantFieldDataList.filter((grantFieldData: any) => {
          // console.log('grantFieldData.grant_field_code: ', grantFieldData.grant_field_code, typeof(grantFieldData.grant_field_code))
          // console.log('grantFieldID: ', grantFieldID, typeof(grantFieldID))
          // console.log('grantFieldData.grant_field_code === grantFieldID: ', String(grantFieldData.grant_field_code) === String(grantFieldID))
          // console.log('\n\n')
          return String(grantFieldData.grant_field_code) === grantFieldID
        })
        console.log('grantFieldDataList', current(grantFieldDataList))
        console.log('highlightedGrantFieldData', highlightedGrantFieldData)
        console.log('highlightedGrantFieldData[0]', highlightedGrantFieldData[0])
        if (highlightedGrantFieldData.length === 1) {
          state.highlightedGrantFieldData = highlightedGrantFieldData[0].impact_entity_node_size_list
        } else {
          console.log('error in dataReducer: highlightedGrantFieldData.length === 0')
        }
      }
      break
    // yifang: end
    case ActionType.GET_MAINVIEW_IMPACT_SUMMARY_TABLE_DATA:
      state.mainviewImpactSummaryTableData = action.payload
      break

    // loading related
    case ActionType.UPDATE_MAIN_VIEW_LOADING_LABEL:
      // console.log(
      //   `[Reducer] Updating mainViewLoadingLabel to: "${action.mainViewLoadingLabel}" at: \n ${new Intl.DateTimeFormat('en-US', {
      //     timeZone: 'America/New_York',   // 换成你的本地时区
      //     year: 'numeric',
      //     month: '2-digit',
      //     day: '2-digit',
      //     hour: '2-digit',
      //     minute: '2-digit',
      //     second: '2-digit'
      //   }).format(new Date())}`
      // );
      state.mainViewLoadingLabel = action.mainViewLoadingLabel
      break
    case ActionType.UPDATE_MAIN_VIEW_LOADING:
      state.isMainViewLoading = action.isMainViewLoading
      break
    case ActionType.UPDATE_GRANT_VIEW_LOADING:
      state.isGrantViewLoading = action.isGrantViewLoading
      break
    case ActionType.UPDATE_PI_VIEW_LOADING:
      state.isPIViewLoading = action.isPIViewLoading
      break
    case ActionType.UPDATE_IMPACT_ENTITY_VIEW_LOADING:
      state.isImpactEntityViewLoading = action.isImpactEntityViewLoading
      break
    case ActionType.UPDATE_IMPACT_STATISRICS_VIEW_LOADING:
      state.isImpactStatisticsViewLoading = action.isImpactStatisticsViewLoading
      break
    default:
      break
  }
  return state
  });

export default reducer;
